import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { ToastService } from 'src/app/core/toast.service';
import { environment } from 'src/environments/environment';

import { addSubscriber, GET_COMMUNITY_MEMBERS_BY_STATUS, GET_JOINED_COMMUNITIES, getAllUserSubscrptions, getClient, practice, practiceDisplay, professional, professionalDeaData, professionalDisplay, supplier, supplierDisplay, UPDATE_DENTAL_PROFESSIONAL, UPDATE_DENTAL_PROFESSIONAL_COMBINED, UPDATE_PROF_NAME, updateDirectoryDetails, updatePracticeDetails, updatePracticeImage, updateProfDetails, updateProfessionalDetails, updateProfImage, updateSubscriber, updateSupplierDetails, updateSupplierImage, GET_PARTNERSHIP_MEMBERS_BY_STATUS, GET_SUPPLIER_COMMUNITY_OWNER, GET_DIRECTORY_BY_LOGIN_TYPE, UPDATE_CLIENT_MUTATION } from '../queries/profile.query';
@Injectable()
export class ProfileService {

  constructor(private apollo: Apollo,private http: HttpClient,private toast: ToastService,) { }


  getUserProfileProfessional(id){
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: professionalDeaData,
      variables: {id}
    }).pipe(pluck('data', 'dental_professionals_by_pk'));
  }

  getUserData(id){
    console.log(id)
    return this.apollo.subscribe({
      query: getClient,
      variables: {id}
    }).pipe(pluck('data', 'clients_by_pk'));
  }

  getUserProfileSuplier(id){
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: supplier,
      variables: {id}
    }).pipe(pluck('data', 'dental_suppliers_by_pk'));
  }

  getUserProfilePracice(id){
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: practice,
      variables: {id}
    }).pipe(pluck('data', 'dental_practices_by_pk'));
  }


  getProfDisplay(id){
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: professionalDisplay,
      variables: {id}
    }).pipe(pluck('data', 'dental_professionals_by_pk'));
  }

  getSupplierDisplay(id){
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: supplierDisplay,
      variables: {id}
    }).pipe(pluck('data', 'dental_suppliers_by_pk'));
  }

  getPracticeDisplay(id){
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: practiceDisplay,
      variables: {id}
    }).pipe(pluck('data', 'dental_practices_by_pk'));
  }

  getuserSub(id: string): Observable<any> {
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: getAllUserSubscrptions,
      variables: {id}
    }).pipe(pluck('data', 'user_subscriptions'));
  }



 async checkData(phoneObj){

    //const a = {object:phoneObj}

      try {
      const response = await this.http.post(`${environment.serverPath}/api/v1/auth/send-verify-otp`, phoneObj).toPromise();
      console.log('email test rk');
      return response;
    } catch (error) {
      console.log(error)
      throw error;
    }



  }


// async checkData(phoneObj){

//   //const a = {object:phoneObj}

//     try {
//     const response = await this.http.post(`${environment.serverPath}/api/v1/auth/send-verify-otp`, phoneObj).toPromise();
//     return response;
//   } catch (error) {
//     console.log(error)
//     throw error;
//   }



// }


​
async verifyOtp(otpData){

  console.log(otpData)

  try {
    const response = await this.http.post(`${environment.serverPath}/api/v1/auth/verify-otp`, otpData).toPromise();
    return response;
  } catch (error) {
    console.log(error)
    throw error;
  }


}
  

   // async register(user): Promise<any> {

  //   let headers = {"x-hasura-admin-secret":`${environment.x_hasura_admin_secret}`};
  //   //headers.append('Content-Type', 'application/json');
  //   //headers.append('x-hasura-admin-secret', `${environment.x_hasura_admin_secret}`);
  //   console.log(user)
  //   const a = {object:user}
  //   try {
  //     const response = await this.http.post(`${environment.serverBasePath}/api/rest/add-lead`, a, { headers : headers }).toPromise();
  //     return response;
  //   } catch (error) {
  //     console.log(error)
  //     throw error;
  //   }
  // }





  // async updateProf(id,profObj):Promise<any>{
  //   console.log('profObj,',profObj)
  //   console.log(id)
  
  //   try{
      
  //    await this.apollo.use("external").mutate({
  //     mutation: updateProfDetails,
  //     variables: {id,profObj}
  //   }).pipe(pluck('data', 'update_dental_professionals_by_pk')).toPromise();
    
  //       return true
  //   }catch (err) {
  //           console.log(err);
  //           return false
  //          }
    
  // }


  async updateDirectory(id, dirObj): Promise<any> {
    console.log('dirObj,',dirObj)

  try {
    await this.apollo.use("external").mutate({
      mutation: updateDirectoryDetails,
      variables: { id, dirObj }
    })
    .pipe(pluck('data', 'update_directories_by_pk'))
    .toPromise();

    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
}



  async updateSupplier(id, supplierObj):Promise<any>{
    console.log(id,supplierObj)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: updateSupplierDetails,
      variables: {id,supplierObj}
    }).pipe(pluck('data', 'update_dental_suppliers')).toPromise();
     this.toast.openSnackBar(
          'Your Details Updated SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update');
            return false
           }
    
  }


  async updatePractice(id,practiceObj):Promise<any>{
    console.log(practiceObj)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: updatePracticeDetails,
      variables: {id,practiceObj}
    }).pipe(pluck('data', 'update_dental_practices')).toPromise();
     this.toast.openSnackBar(
          'Your Details Updated SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update ');
            return false
           }
    
  }


  async updateUserImageProf(id,userImage):Promise<any>{
    console.log(userImage)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: updateProfImage,
      variables: {id,userImage}
    }).pipe(pluck('data', 'update_dental_professionals')).toPromise();
     this.toast.openSnackBar(
          'Your Details Updated SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update ');
            return false
           }
    
  }

  async updateUserImageSupplier(id,userImage):Promise<any>{
    console.log(userImage)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: updateSupplierImage,
      variables: {id,userImage}
    }).pipe(pluck('data', 'update_dental_suppliers')).toPromise();
     this.toast.openSnackBar(
          'Your Details Updated SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update ');
            return false
           }
    
  }

  async updateUserImagePractice(id,userImage):Promise<any>{
    console.log(userImage)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: updatePracticeImage,
      variables: {id,userImage}
    }).pipe(pluck('data', 'update_dental_practices')).toPromise();
     this.toast.openSnackBar(
          'Your Details Updated SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update ');
            return false
           }
    
  }

  //  Add New Subscriber
  async addSubscriber(formData: any): Promise<boolean> {
    try {
      await this.apollo.use("external").mutate({
        mutation: addSubscriber,
        variables: { object: formData }
      }).pipe(pluck('data', 'insert_dental_professionals_one')).toPromise();

      this.toast.openSnackBar('Details added successfully');
      return true;
    } catch (err) {
      console.error(err);
      this.toast.openSnackBar('Failed to add details');
      return false;
    }
  }

   //  Update Existing Subscriber
  async updateSubscriber(id: string, formData: any): Promise<boolean> {
    try {
      await this.apollo.use("external").mutate({
        mutation: updateSubscriber,
        variables: { id, _set: formData }
      }).pipe(pluck('data', 'update_dental_professionals_by_pk')).toPromise();

      this.toast.openSnackBar('Details updated successfully');
      return true;
    } catch (err) {
      console.error(err);
      this.toast.openSnackBar('Failed to update details');
      return false;
    }
  }

  //  Update Existing Professional Details
//  Update Existing Professional Details
async submitProfessionalDetails(id: string, formData: any): Promise<boolean> {
  try {
    await this.apollo.use("external").mutate({
      mutation: updateProfessionalDetails,
      variables: { id, _set: formData }
    }).pipe(pluck('data', 'update_dental_professionals_by_pk')).toPromise();

    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
}

async updateProfessional(id: string, profObj: any): Promise<boolean> {
  try {
    await this.apollo.use("external").mutate({
      mutation: updateProfDetails,
      variables: { id, profObj }
    }).pipe(pluck('data', 'update_dental_professionals_by_pk')).toPromise();

    this.toast.openSnackBar('Details updated successfully');
    return true;
  } catch (err) {
    console.error(err);
    this.toast.openSnackBar('Failed to update details');
    return false;
  }
}
 async updateDentalProfessional(id: string, updateObj: any): Promise<boolean> {
    try {
      await this.apollo.use('external').mutate({
        mutation: UPDATE_DENTAL_PROFESSIONAL,
        variables: { id, _set: updateObj }
      }).pipe(pluck('data', 'update_dental_professionals_by_pk')).toPromise();

      return true;
    } catch (err) {
      console.error('Error updating dental professional:', err);
      return false;
    }
  }

  async updateDentalProfessionalCombined(
    id: string,
    otherDetailsObj: any
  ): Promise<boolean> {

    console.log("other detsils>>?>>>>>>>>>", otherDetailsObj)
    try {
      await this.apollo.use('external').mutate({
        mutation: UPDATE_DENTAL_PROFESSIONAL_COMBINED,
        variables: { id, _set: otherDetailsObj }
      }).pipe(pluck('data', 'update_dental_professionals_by_pk')).toPromise();

      return true;
    } catch (err) {
      console.error('Error updating dental professional (combined):', err);
      return false;
    }
  }

  async updateProf(id: string, profObj: any): Promise<boolean> {
    try {
      await this.apollo.use('external').mutate({
        mutation: UPDATE_PROF_NAME,
        variables: { id, _set: profObj }
      }).pipe(pluck('data', 'update_dental_professionals_by_pk')).toPromise();

      return true;
    } catch (err) {
      console.error('Error updating name:', err);
      return false;
    }
  }

  getCommunityMembersByStatus(
    supplier_id: string,
    status: string,
    limit: number,
    offset: number
  ): Observable<any> {
    const where: any = {
      supplier_id: { _eq: supplier_id }
    };

    switch (status) {
      case 'ALL':
        // Fetch everyone — registered or not
        where._or = [
          { is_registered: { _eq: true } },
          { status: { _in: ['PENDING', 'APPROVED', 'REJECTED'] } }
        ];
        break;

      case 'REGISTERED':
        // Only registered
        where.is_registered = { _eq: true };
        break;

      case 'PENDING':
      case 'APPROVED':
      case 'REJECTED':
        // Filter by status
        where.status = { _eq: status };
        break;

      default:
        // Fallback → same as ALL
        where._or = [
          { is_registered: { _eq: true } },
          { status: { _in: ['PENDING', 'APPROVED', 'REJECTED'] } }
        ];
        break;
    }

    return this.apollo
      .watchQuery<any>({
        query: GET_COMMUNITY_MEMBERS_BY_STATUS,
        variables: { where, limit, offset },
        fetchPolicy: 'network-only'
      })
      .valueChanges.pipe(map(result => result.data.community_members));
  }




  getJoinedCommunities(practiceId: string) {
    return this.apollo.watchQuery<any>({
      query: GET_JOINED_COMMUNITIES,
      variables: { member_id: practiceId},
      fetchPolicy: 'network-only'
    }).valueChanges.pipe(
      map(result => result.data.community_members)
    );
  }

  getPartnershipRequestsByStatus(
    supplier_id: string,
    status: string,
    limit: number,
    offset: number
  ): Observable<any> {
    let where: any = {
      supplier_id: { _eq: supplier_id },
      type: { _eq: "PARTNERSHIP" }
    };

    switch (status) {
      case 'ALL':
        where._or = [
          { status: { _in: ['PENDING', 'APPROVED', 'REJECTED'] } },
          { is_registered: { _eq: true } }
        ];
        break;

      case 'Partnership Request':
        where.is_registered = { _eq: true };
        break;

      case 'PENDING':
      case 'APPROVED':
      case 'REJECTED':
        where.status = { _eq: status };
        break;

      default:
        where.status = { _in: ['PENDING', 'APPROVED', 'REJECTED'] };
        break;
    }

    return this.apollo
      .watchQuery<any>({
        query: GET_PARTNERSHIP_MEMBERS_BY_STATUS,
        variables: { where, limit, offset },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map(result => result.data.partnership_members));
  }

  getCommunitySupplier(supplierId: string) {
    return this.apollo.watchQuery<any>({
      query: GET_SUPPLIER_COMMUNITY_OWNER,
      variables: { dental_supplier_id: supplierId },
      fetchPolicy: 'network-only'
    }).valueChanges.pipe(
      map(result => result.data.dental_suppliers)
    );
  }

  getDirectoryByLoginType(id: string, type: string): Observable<any> {
    let whereClause: any = {};

    if (type === 'SUPPLIER') {
      whereClause = { dental_supplier_id: { _eq: id } };
    } else {
      return new Observable((observer) => {
        observer.next(null);
        observer.complete();
      });
    }

    return this.apollo
      .watchQuery<any>({
        query: GET_DIRECTORY_BY_LOGIN_TYPE,
        variables: { where: whereClause },
      })
      .valueChanges.pipe(map((res) => res?.data?.directories?.[0]));
  }

async updateClientFromSupplier(id: string, payload: any) {
  return this.apollo.mutate({
    mutation: UPDATE_CLIENT_MUTATION,  // <-- you need this mutation
    variables: {
      id,
      changes: payload // Hasura expects `clients_set_input`
    }
  }).toPromise();
}


}
